
import Vue from "vue";
import AppCompanies from "../components/statistics/Companies.vue";
import { ISalesBetweenWrapper, StatisticsService} from "@/services/statistics-service";
import {CompanyStatsFilter} from "@/utils/company-stats-filter";

Vue.filter("formatNumber", function (value: any) {
	return value ? "€ " + parseFloat(value).toFixed(0) : "€ " + 0.00; // displaying other groupings/separators is possible, look at the docs
});

export default Vue.extend({
	data() {
		return {
			results: {
				Left: {
					tier1: "0",
					tier2: "0",
					tier3: "0"
				},
				Right: {
					tier1: "0",
					tier2: "0",
					tier3: "0"
				}
			} as ISalesBetweenWrapper,
			filter1: {year: (new Date().getFullYear() - 1), mode: 13} as CompanyStatsFilter,
			filter2: {year: new Date().getFullYear(), mode: 13} as CompanyStatsFilter
		};
	},
	computed: {
		totalLeft():Number{
			return parseFloat(this.results.Left.tier1 || "0") + parseFloat(this.results.Left.tier2 || "0") + parseFloat(this.results.Left.tier3 || "0");
		},
		totalRight():Number{
			return parseFloat(this.results.Right.tier1 || "0") + parseFloat(this.results.Right.tier2 || "0") + parseFloat(this.results.Right.tier3 || "0");
		}
	},
	methods: {
		difference(l: string, r: string): string {
			if (parseFloat(l) == parseFloat(r)) {
				return "";
			}
			return parseFloat(l) > parseFloat(r) ? "red" : "green";
		},
		icon(l: string, r: string): string {
			if (parseFloat(l) == parseFloat(r)) {
				return "";
			}
			return parseFloat(l) > parseFloat(r) ? "arrow-down" : "arrow-up";
		},
		percentage(l: string, r: string): string {
			let left = Math.round(Number(l));
			let right = Math.round(Number(r));

			let x = right / left;
			let y = x * 100;
			let z = y - 100;

			if (z == Number.POSITIVE_INFINITY || z == Number.NEGATIVE_INFINITY) {
				z = 0;
			}
			return z.toFixed(0);

		},
		updateFilter1(e: CompanyStatsFilter) {
			this.filter1 = e;
			this.fetch();
		},
		updateFilter2(e: CompanyStatsFilter) {
			this.filter2 = e;
			this.fetch();
		},
		async fetch() {

			this.results = await StatisticsService.getSalesResults(this.filter1, this.filter2);
			/*if (this.mode == Mode.WEEK) {
        this.result = await StatisticsService.getNewDemosLastWeek();
      } else if (this.mode == Mode.MONTH) {f
        this.result = await StatisticsService.getNewDemosLastMonth();
      } else if (this.mode == Mode.HALF_YEAR) {
        this.result = await StatisticsService.getNewDemosLastHalfYear();
      } else if (this.mode == Mode.YEAR) {
        this.result = await StatisticsService.getNewDemosLastYear();
      }*/

		},
		convertModesToDates(filter: CompanyStatsFilter) {

			switch (filter.mode) {

			case 13: //7days
				let d = new Date();
				d.setFullYear(filter.year);
				return {
					from: new Date(d.getTime() + (-7 * 24 * 60 * 60 * 1000)).toISOString().split("T")[0],
					till: d.toISOString().split("T")[0]
				};
				break;

			}

		}
	},
	created() {
		this.filter1.mode = new Date().getMonth() + 1;
		this.filter2.mode = new Date().getMonth() + 1;
		this.fetch();
	},
	components: {
		AppCompanies
	}
});
